
import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const PRODUCTS = [
    { id: 'prod-1', name: 'Starter kit', sku: 'SKU-001', price: 49.99, currency: 'EUR', status: 'active' },
    { id: 'prod-2', name: 'Pro bundle', sku: 'SKU-002', price: 129.0, currency: 'EUR', status: 'active' },
    { id: 'prod-3', name: 'Legacy item', sku: 'SKU-OLD', price: 9.99, currency: 'EUR', status: 'inactive' },
];
const ORDERS = [
    { order_id: 'ord-1001', status: 'pending', customer_name: 'Jane Demo', phone: '+1 555 0100', email: 'jane@yopmail.com', created_at: '2026-06-04T08:00:00Z' },
    { order_id: 'ord-1002', status: 'fulfilled', customer_name: 'ACME Corp', phone: '+1 555 0101', email: 'billing@acme.test', created_at: '2026-06-03T12:00:00Z' },
];
const RENTALS = [
    { id: 'rent-1', title: 'Conference room A', status: 'available', available_from: '2026-06-10', available_to: '2026-06-12', updated_at: '2026-06-04T10:00:00Z' },
    { id: 'rent-2', title: 'Projector pack', status: 'booked', available_from: '2026-06-05', available_to: '2026-06-05', updated_at: '2026-06-02T10:00:00Z' },
];

function productId(url: string): string | undefined {
    const m = url.match(/\/products\/([^/?]+)/i);
    return m?.[1];
}

export const STORE_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/store\/products/i,
        handler: (req) => {
            const admin = req.url.includes('scope=admin');
            const items = admin ? PRODUCTS : PRODUCTS.filter((p) => p.status === 'active');
            return mockSuccess(listPayload(items));
        },
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/store\/orders/i,
        handler: () => mockSuccess(listPayload(ORDERS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/store\/rentals/i,
        handler: () => mockSuccess(listPayload(RENTALS)),
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/store\/products(\?|$)/i,
        handler: (req) => {
            const body = (req.body || {}) as Record<string, unknown>;
            const next = {
                id: `prod-${PRODUCTS.length + 1}`,
                name: String(body['name'] || 'New product'),
                sku: String(body['sku'] || ''),
                price: Number(body['price'] || 0),
                currency: String(body['currency'] || 'EUR'),
                status: String(body['status'] || 'active'),
            };
            PRODUCTS.push(next);
            return mockSuccess(next);
        },
    },
    {
        method: 'PATCH',
        pattern: /\/api\/[^/]+\/[^/]+\/store\/products\/[^/?]+/i,
        handler: (req) => {
            const id = productId(req.url);
            const row = PRODUCTS.find((p) => p.id === id);
            if (row) {
                Object.assign(row, req.body as object);
            }
            return mockSuccess(row ?? PRODUCTS[0]);
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/store\/orders/i,
        handler: (req) => {
            const body = (req.body || {}) as Record<string, string>;
            const next = {
                order_id: `ord-${1000 + ORDERS.length + 1}`,
                status: 'pending',
                customer_name: body['customer_name'] || 'Guest',
                phone: body['phone'] || '',
                email: body['email'] || '',
                created_at: new Date().toISOString(),
            };
            ORDERS.push(next);
            return mockSuccess(next);
        },
    },
];
